import { makeStyles } from '@material-ui/styles';
import { Theme } from '@bizzabo/design-system';

interface AdaChatStylesProps {
    isExpanded: boolean;
    shouldShowExpandAnimation: boolean;
    shouldShowCollapseAnimation: boolean;
}

const getExpandedChatBotStyles = (theme: Theme, props: AdaChatStylesProps) => {
    const { isExpanded, shouldShowExpandAnimation, shouldShowCollapseAnimation } = props;
    const shouldDisableAnimation =
        isExpanded && !shouldShowExpandAnimation && !shouldShowCollapseAnimation;
    const opacityChangeDelay = shouldShowExpandAnimation ? 300 : 0;

    return {
        transform: `translate(${shouldShowCollapseAnimation ? 300 : 0}px, 0) !important`,
        opacity: `${shouldShowCollapseAnimation ? 0 : 1} !important`,
        zIndex: `${shouldShowCollapseAnimation ? 1000 : 1001} !important`,
        transition: shouldDisableAnimation
            ? 'none !important'
            : `transform 300ms, opacity 200ms ease ${opacityChangeDelay}ms !important`,

        [theme.breakpoints.down('sm')]: {
            transition: isExpanded ? 'all 200ms !important' : 'none !important',
        },
    };
};

export const useStyles = (props: AdaChatStylesProps) =>
    makeStyles<Theme>(
        theme => ({
            header: {
                padding: '40px 30px 20px',
                color: theme.palette.greys[400],
            },
            '@global': {
                '#ada-chat-frame': {
                    right: '130px !important',
                    left: 'unset !important',
                    bottom: '-14px !important',
                    top: 'unset !important',
                    boxShadow: 'none !important',
                    height: 'calc(100% + 24px) !important',
                    maxHeight: 'unset !important',
                    width: 'calc(33vw - 160px) !important',
                    minWidth: '315px !important',
                    maxWidth: '440px !important',
                    transform: `translate(0, 0) !important`,
                    borderRadius: '0 0 0 33px !important',
                    clipPath: 'inset(97px 0 0 0) !important',

                    [theme.breakpoints.down('sm')]: {
                        padding: '0 20px',
                        width: '100% !important',
                        left: '0 !important',
                        right: '0 !important',
                        bottom: '66px !important',
                        maxWidth: '100% !important',
                        height: 'calc(85% - 50px) !important',
                        clipPath: 'inset(104px 0 0 0) !important',
                        borderRadius: '0px !important',
                        transition: 'none !important',
                    },

                    '&[aria-expanded=true]': getExpandedChatBotStyles(theme, props),
                },
            },
        }),
        { classNamePrefix: 'ada-chat-wrapper' }
    );
